import React from 'react';
import { LIFE_INSURANCE as lifeInsurancePagePosition } from 'types/morph.pagePosition.constants';
import { useLinkHandler } from 'hook/event.hook';
import { useLifeInsurance } from './hooks/LifeInsurance.hook';
import { LifeInsuranceModuleView } from './LifeInsuranceModuleView';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { LIFE_INSURANCE_VERTICAL } from 'types/marketplaceTiles.constants';

const LifeInsuranceModuleController = props => {
  const { eventHandler, config, userInfo, datatestid, modulePosition } = props;
  const onLinkClickCallback = useLinkHandler(eventHandler);

  const liConfig = config?.marketplace?.li;

  let typeOfCoverage = liConfig?.typeOfCoverage;
  let amountOfCoverage = liConfig?.amountOfCoverage;
  let checkBoxList = liConfig?.checkBoxList;

  const {
    states,
    setStates,
    onLifeInsuranceSearch,
    onSelectMultiQuestionOptions,
    handleShowFilters,
    handleFilterValue,
  } = useLifeInsurance(liConfig, userInfo, eventHandler);

  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes({
      pagePosition: lifeInsurancePagePosition,
      modulePosition,
      vertical: LIFE_INSURANCE_VERTICAL,
    }),
  );

  return (
    <LifeInsuranceModuleView
      {...props}
      seenPixel={seenPixel}
      onLinkClickCallback={onLinkClickCallback}
      datatestid={datatestid}
      typeOfCoverage={typeOfCoverage}
      amountOfCoverage={amountOfCoverage}
      checkBoxList={checkBoxList}
      onSelectMultiQuestionOptions={onSelectMultiQuestionOptions}
      onLifeInsuranceSearch={onLifeInsuranceSearch}
      handleShowFilters={handleShowFilters}
      handleFilterValue={handleFilterValue}
      states={states}
      setStates={setStates}
    />
  );
};

export default LifeInsuranceModuleController;
